import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../store';

const API_URL = process.env.REACT_APP_BACKEND_URL || (typeof window !== 'undefined' ? ((window.location.hostname === 'devapp.soviewfx.fr' || window.location.hostname === 'devadmin.soviewfx.fr') ? 'https://devhub.soviewfx.fr' : ((window.location.hostname === 'app.soviewfx.fr' || window.location.hostname === 'admin.soviewfx.fr') ? 'https://hub.soviewfx.fr' : '')) : '');

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser, setToken } = useAuthStore();
  const hasProcessed = useRef(false);
  
  useEffect(() => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    
    const processOAuth = async () => {
      // Extract session_id from hash
      const hash = window.location.hash;
      const match = hash.match(/session_id=([^&]+)/);
      
      if (!match) {
        navigate('/home');
        return;
      }
      
      const sessionId = match[1];
      
      try {
        // Exchange session_id for user data
        const response = await fetch(`${API_URL}/api/auth/session`, {
          method: 'GET',
          headers: {
            'X-Session-ID': sessionId
          },
          credentials: 'include'
        });
        
        if (!response.ok) {
          throw new Error('OAuth failed');
        }
        
        const user = await response.json();
        setUser(user);
        
        // Clear hash and redirect
        window.history.replaceState(null, '', window.location.pathname);
        navigate('/home', { state: { user } });
      } catch (error) {
        console.error('OAuth error:', error);
        navigate('/home');
      }
    };
    
    processOAuth();
  }, [navigate, setUser, setToken]);
  
  return (
    <div className="h-full w-full flex items-center justify-center bg-background">
      <div className="spinner" />
    </div>
  );
}
